import { getCustomizationOptions } from '@va/dashboard/selectors/customization';
import { SettingsHeading } from '@va/dashboard/ui/pages';
import { GlobeIcon } from '@va/icons';
import { useTranslate } from '@va/localization';
import { contributorRole } from '@va/standalone/shared/selectors';
import { Button, InputWithSubsection } from '@va/ui/design-system';
import { useSelector } from 'react-redux';
import useDomainWhitelistingCard from './useDomainWhitelistingCard';

export const DomainWhitelistingCard = () => {
  const translate = useTranslate();

  const {
    whitelistedDomains,
    inputValue,
    onRemove,
    onSubmit,
    onChange,
    successSubmit,
    error,
    hasMadeChanges,
    onSave,
    isLoading,
    isLoadingUpdateCall,
  } = useDomainWhitelistingCard();
  const { providerName, supportCenterDomain } = useSelector(getCustomizationOptions);
  const isContributor = useSelector(contributorRole);

  return (
    <div className='flex flex-col gap-18px items-start'>
      <SettingsHeading
        title={translate('card.whiteListing.title')}
        subText={translate('card.whiteListing.whitelistingDescription')}
        tooltip={translate('card.whiteListing.tooltip', { providerName, supportCenterDomain })}
      />
      <div className='flex flex-col gap-4 w-full'>
        <InputWithSubsection
          disabled={isContributor}
          infoTooltip={isContributor ? translate('tooltips.contributorRole') : undefined}
          isLoading={isLoading}
          onSubmit={onSubmit}
          onRemove={onRemove}
          listItems={whitelistedDomains ?? []}
          icon={<GlobeIcon color='#3C3C3C' />}
          itemsLabel={translate('card.whiteListing.domain.items.label')}
          successSubmit={successSubmit}
          inputProps={{
            value: inputValue,
            onChange: onChange,
            placeholder: translate('card.whiteListing.whiteListingPlaceholder'),
            name: 'domainWhitelistingInput',
            label: translate('card.whiteListing.domain.label'),
          }}
          error={error}
        />
        {hasMadeChanges && (
          <Button
            disabled={isLoadingUpdateCall}
            className='w-full'
            onClick={onSave}
            text={translate('button.saveChanges')}
          />
        )}
      </div>
    </div>
  );
};
